import axios from 'axios';

const api = axios.create({
  baseURL: '/api',
  timeout: 30000
});

api.interceptors.response.use(
  response => response.data,
  error => {
    console.error('API Error:', error);
    return Promise.reject(error);
  }
);

export const searchResources = (params) => {
  return api.get('/search', { params });
};

export const searchPoll = (params) => {
  return api.get('/search/poll', { params });
};

export const getRanking = (params) => {
  return api.get('/ranking', { params });
};

export const getHome = (params) => {
  return api.get('/home', { params });
};
